import React from 'react'

function Location() {
  return (
    <>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.833026526931!2d36.96690327386288!3d-1.2733649356098196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f4177c8f71071%3A0xdaa84be278aed33c!2sMORARA%20HOME%20FURNITURE!5e0!3m2!1sen!2ske!4v1759436022087!5m2!1sen!2ske" width="100%" height="350"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </>
  )
}

export default Location
